(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["packs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('packs-selector')) {
    class PacksSelector extends HTMLElement {
      connectedCallback() {
        this.updatePromo();
        this.inputs = Array.from(this.querySelectorAll('.packs__input'));
        this.inputs.forEach((input) => {
          input.addEventListener('change', () => {
            if (input.checked) this.applyQuantity(parseInt(input.value, 10));
          });
        });
        this.onQuantityUpdate = (event) => {
          if (!event.detail || event.detail.cartLine) return;
          if (this.contains(event.target)) return;
          this.syncSelection(event.detail.quantity);
        };
        document.addEventListener('quantity-selector:update', this.onQuantityUpdate);
      }

      disconnectedCallback() {
        document.removeEventListener('quantity-selector:update', this.onQuantityUpdate);
        clearTimeout(this.promoTimer);
      }

      updatePromo() {
        const start = parseInt(this.dataset.start || '0', 10) * 1000;
        const active = !start || Date.now() >= start;
        this.toggleAttribute('data-promo', active);
        clearTimeout(this.promoTimer);
        const delay = start - Date.now();
        if (!active && delay < 2147483000) {
          this.promoTimer = setTimeout(() => this.updatePromo(), delay + 1000);
        }
      }

      getQuantitySelector() {
        const section = this.closest('.shopify-section') || document;
        return section.querySelector('product-form-component quantity-selector-component');
      }

      applyQuantity(quantity) {
        const selector = this.getQuantitySelector();
        if (!selector || typeof selector.setValue !== 'function') return;
        const max = typeof selector.getEffectiveMax === 'function' ? selector.getEffectiveMax() : null;
        const value = max !== null && max !== undefined ? Math.min(quantity, max) : quantity;
        selector.setValue(String(value));
        if (typeof selector.updateButtonStates === 'function') selector.updateButtonStates();
        if (typeof selector.onQuantityChange === 'function') selector.onQuantityChange();
        if (value !== quantity) this.syncSelection(value);
      }

      syncSelection(quantity) {
        this.inputs.forEach((input) => {
          input.checked = parseInt(input.value, 10) === quantity;
        });
      }
    }
    customElements.define('packs-selector', PacksSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
